import React, { Component } from "react";
import ActivityAdmin from "./ActivityAdmin";
import ActivityPackAdmin from "./ActivityPackAdmin";
import RecommendationAdmin from "./RecommendationAdmin";

export default class ActivityAdminSelector extends Component {
  state = {
    view: "Activity",
  };

  render() {
    return (
      <>
        <section className="section">
          <div className="container">
            <h1>Aktivitet Admin</h1>
            <br />
            <button
              style={{
                fontSize: "20px",
                border:
                  this.state.view == "Activity" ? "3px solid #5dab71" : "",
                color: this.state.view == "Activity" ? "#5dab71" : "",
                background: "white",
                borderRadius: "12px",
                padding: "5px 10px",
              }}
              onClick={() => {
                this.setState({ view: "Activity" });
              }}
            >
              Aktivitet
            </button>
            <button
              style={{
                fontSize: "20px",
                border:
                  this.state.view == "Activitypack" ? "3px solid #5dab71" : "",
                color: this.state.view == "Activitypack" ? "#5dab71" : "",
                marginLeft: "10px ",
                background: "white",
                borderRadius: "12px",
                padding: "5px 10px",
              }}
              onClick={() => {
                this.setState({ view: "Activitypack" });
              }}
            >
              Aktivitetspakker
            </button>
            <button
              style={{
                fontSize: "20px",
                border:
                  this.state.view == "Recommendations"
                    ? "3px solid #5dab71"
                    : "",
                color:
                  this.state.view == "Recommendations" ? "#5dab71" : "",
                marginLeft: "10px ",
                background: "white",
                borderRadius: "12px",
                padding: "5px 10px",
              }}
              onClick={() => {
                this.setState({ view: "Recommendations" });
              }}
            >
              Anbefalinger
            </button>
            <br />
            {this.state.view == "Activity" && <ActivityAdmin />}
            {this.state.view == "Activitypack" && <ActivityPackAdmin />}
            {this.state.view == "Recommendations" && (
              <RecommendationAdmin auth={this.props.auth} />
            )}
          </div>
        </section>
      </>
    );
  }
}
